export enum INTEGRATION_STATUS {
  HEALTHY = 'HEALTHY',
  WARNING = 'WARNING',
  UNHEALTHY = 'UNHEALTHY',
  DISABLE = 'DISABLE',
}

export const IntegrationStatusMap = new Map<INTEGRATION_STATUS, string>([
  [INTEGRATION_STATUS.HEALTHY, 'Healthy'],
  [INTEGRATION_STATUS.WARNING, 'Unstable'],
  [INTEGRATION_STATUS.UNHEALTHY, 'Suspended'],
  [INTEGRATION_STATUS.DISABLE, 'Disabled'],
]);
